import { Box } from "@mui/material";
import {
  getBackgroundStyles,
  normalizeBackgroundFitValue,
} from "../../core/utils/themeConfig";

/**
 * Full-bleed hero background, matching how professional sites fill a viewport:
 * the image always covers the frame, stays centered, and scales with the screen.
 * Overflow is cropped; the picture is never letterboxed.
 */
const heroCoverSx = (blurPx) => ({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center",
  filter: blurPx > 0 ? `blur(${blurPx}px)` : "none",
  transform: blurPx > 0 ? "scale(1.12)" : "none",
  transformOrigin: "center",
});

export default function ThemeBackdrop({
  url = "",
  fit = "fill",
  blur = 8,
  overlay = 0,
  overlayEnabled = true,
}) {
  const mode = normalizeBackgroundFitValue(fit);
  const hasImage = Boolean(url);
  const overlayAmount = overlayEnabled ? Number(overlay) || 0 : 0;
  const blurPx = Math.max(0, Number(blur) || 0);

  return (
    <Box
      aria-hidden
      sx={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        pointerEvents: "none",
        backgroundColor: "#0a0a0a",
      }}
    >
      {hasImage && (mode === "fill" || mode === "center") ? (
        <Box component="img" src={url} alt="" draggable={false} sx={heroCoverSx(blurPx)} />
      ) : null}

      {hasImage && mode === "fit" ? (
        <Box
          component="img"
          src={url}
          alt=""
          draggable={false}
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "contain",
            objectPosition: "center",
          }}
        />
      ) : null}

      {hasImage && mode === "stretch" ? (
        <Box
          component="img"
          src={url}
          alt=""
          draggable={false}
          sx={{
            ...heroCoverSx(blurPx),
            objectFit: "fill",
          }}
        />
      ) : null}

      {hasImage && mode === "tile" ? (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            ...getBackgroundStyles(url, "tile"),
          }}
        />
      ) : null}

      {overlayAmount > 0 ? (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 1,
            background: `rgba(0,0,0,${overlayAmount / 100})`,
          }}
        />
      ) : null}
    </Box>
  );
}
